import React from "react";
import styles from "./FixesChatbot.module.css";
import { ArrowRight } from "lucide-react";

const FixesChatbot = () => {
    return (
        <section className={styles.hero}>
            <div className={styles.container}>
                <p className={styles.subText}>
                    If your website isn't converting,
                    <br />
                    it's not a traffic problem —{" "}
                    <span>it's an interaction problem.</span>
                </p>

                <h1 className={styles.heading}>ToxboxAI fixes that.</h1>

                <button className={styles.button}>
                    Get Started Free
                    <ArrowRight size={18} />
                </button>
            </div>
        </section>
    );
};

export default FixesChatbot;